import React, { useEffect, useState } from 'react';
import useFetch from '../../hooks/useFetch';

const API_URL = process.env.REACT_APP_API_URL;

const Logo = () => {
    const { data } = useFetch(`${API_URL}/logos?populate=logoImage`);


    const logo = data?.[0];
    return (
        <div className="right">
            {logo && (
                <div className="media" key={logo.id}>
                    {logo.logoImage?.[0]?.url && (
                        <>
                            <img
                                src={process.env.REACT_APP_UPLOAD_URL + logo?.logoImage?.[0]?.url}
                                alt="Logo"
                                loading="lazy"
                            />

                        </>
                    )}
                </div>
            )}
        </div>
    )
};

export default Logo;
